const Grid = () => {
  return {
    MuiGrid: {
      styleOverrides: {},
    },
  }
}

export default Grid
